import de from './lang/de.json';

export default de.translation;
